import HakAksesDivisi from './HakAksesDivisi'

export default HakAksesDivisi